module.exports = __webpack_public_path__ + "static/img/3.1.43d4b7cd.png";